import { Skeleton } from "antd"

// A loading table in its own shape: the real columns (headers, widths, alignment) over
// placeholder rows with a bar in every cell, instead of a spinner over an empty body.
export const skeletonRows = (count) => Array.from({ length: count }, (_, key) => ({ key }))

export const skeletonColumns = (columns) =>
  columns.map((column) => ({
    ...column,
    render: () => (
      <Skeleton.Node
        active
        style={{
          width: Math.min(96, (column.width || column.minWidth || 140) - 40),
          height: 14,
          borderRadius: 4
        }}
      />
    )
  }))
